import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';
import { Typography } from '@design-system/components/typography/typography';
import { CaseStudyVM } from '../../view-model/Strategy.viewModel';
import * as styles from './StrategyCaseStudyCard.css';

type StrategyCaseStudyCardProps = {
  caseStudy: CaseStudyVM;
  testId?: string;
  titlePosition?: 'top' | 'bottom';
};

export const StrategyCaseStudyCard = ({
  caseStudy,
  testId,
  titlePosition = 'top',
}: StrategyCaseStudyCardProps) => {
  const imageUrl = caseStudy.coverImageWideUrl ?? caseStudy.coverImageUrl;

  const handleOpenDocument = () => {
    if (caseStudy.documentUrl) {
      window.open(caseStudy.documentUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleOpenInstagram = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (caseStudy.creatorInstagramName) {
      window.open(
        `https://instagram.com/${caseStudy.creatorInstagramName}`,
        '_blank',
        'noopener,noreferrer',
      );
    }
  };

  const handleOpenDocumentIcon = (e: React.MouseEvent) => {
    e.stopPropagation();
    handleOpenDocument();
  };

  return (
    <div
      className={styles.card}
      onClick={handleOpenDocument}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleOpenDocument();
        }
      }}
      data-testid={testId}
    >
      <img src={imageUrl} alt={caseStudy.title} className={styles.image} />

      <div className={styles.overlay}>
        {titlePosition === 'top' && (
          <div className={styles.top}>
            <Typography variant="title" size="large" className={styles.title}>
              {caseStudy.title}
            </Typography>
            <Typography
              variant="body"
              size="medium"
              className={styles.subtitle}
            >
              {caseStudy.subtitle ?? ''}
            </Typography>
          </div>
        )}

        {titlePosition === 'bottom' && <div className={styles.top} />}

        <div className={styles.bottom}>
          <div className={styles.textGroup}>
            {titlePosition === 'bottom' && (
              <>
                <Typography
                  variant="title"
                  size="large"
                  className={styles.title}
                >
                  {caseStudy.title}
                </Typography>
                <Typography
                  variant="body"
                  size="medium"
                  className={styles.subtitle}
                >
                  {caseStudy.subtitle ?? ''}
                </Typography>
              </>
            )}
            <Typography
              variant="body"
              size="medium"
              className={styles.metaPrimary}
            >
              {caseStudy.creatorName}
            </Typography>
            {caseStudy.creatorInstagramName && (
              <Typography
                variant="body"
                size="small"
                className={styles.metaSecondary}
              >
                insta: {caseStudy.creatorInstagramName}
              </Typography>
            )}
          </div>
          <div className={styles.icons}>
            {caseStudy.creatorInstagramName && (
              <FontAwesomeIcon
                icon={faInstagram}
                onClick={handleOpenInstagram}
              />
            )}
            <FontAwesomeIcon
              icon={faArrowUpRightFromSquare}
              onClick={handleOpenDocumentIcon}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
